import { TranslateService } from "./../../shared/translate/translate.service";
import { Location } from "@angular/common";
import { AuthService } from "./../../shared/models/auth.service";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";
import { RoleService } from "../models/role.service";
import { RoleModel } from "../models/role.model";
import { AccessMatrixModel } from "../models/access-matrix.model";

@Component({
  selector: "wego-copy-role-popup",
  template: require('../views/copy-role-popup.component.html')
})
export class CopyRolePopupComponent {
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  selectedRoleHashId: string = "";
  //selectedEntity: string;
  selectedRoleEntity: RoleModel;
  LblIcon: string;
  roleList: RoleModel[];
  accessibilityMatrixList: AccessMatrixModel[];

  public entityName: string;
  @Output("OnSuccessSelect") onSuccessSelect = new EventEmitter();
  @ViewChild("copyRoleModal") public copyRoleModal: any;

  constructor(
    private roleService: RoleService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  GetRoleDropdownList(): any {
    this.isLoading = true;
    this.roleService
      .GetRoleDropdownListByEntity(this.selectedRoleEntity.entity)
      .subscribe(
        res => {
          this.roleList = res.data;
          if (this.roleList) {
            const index: number = this.roleList.findIndex(
              x => x.roleHashId == this.selectedRoleEntity.roleHashId
            );
            if (index !== -1) {
              this.roleList.splice(index, 1);
            }
          }
          this.selectedRoleHashId = "";
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public UpdateAccessMatrix(): any {
    if (this.selectedRoleHashId) {
      this.isLoading = true;
      this.roleService
        .GetAccessibilityMatrixByRoleHashId(this.selectedRoleHashId)
        .subscribe(
          res => {
            this.accessibilityMatrixList = res.data;
            this.isLoading = false;
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public show(): void {
    this.accessibilityMatrixList = [];
    this.GetRoleDropdownList();
    this.copyRoleModal.show();
  }

  public hide(): void {
    this.copyRoleModal.hide();
  }

  public CopyRoleAccessMatrix() {
    this.onSuccessSelect.emit({
      accessibilityMatrixList: this.accessibilityMatrixList
    });
    this.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role-management/components/copy-role-popup.component.ts